import React from 'react'

import { Button } from '../../../elements'

const SiteWizardUpload = props => (
  <div>
    <h2>Upload plan TBD</h2>
    <Button onClick={props.onSubmit} type="primary">Proceed</Button>
  </div>
)

export default SiteWizardUpload



// WEBPACK FOOTER //
// ./src/smart-components/site-creation-wizard/components/site-wizard-upload.js